import { render } from "./yateScreen.vue?vue&type=template&id=55799cea&scoped=true"
import script from "./yateScreen.vue?vue&type=script&lang=js"
export * from "./yateScreen.vue?vue&type=script&lang=js"

import "./yateScreen.vue?vue&type=style&index=0&id=55799cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55799cea"]])

export default __exports__